export default __webpack_public_path__ + "static/press-image-1-9dfa32bd8377acb7bc0b31ff93514313.jpg";